import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

function SolidFacebookMessengerIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 2a9.65 9.65 0 0 0-10 9.7 9.5103 9.5103 0 0 0 3.14 7.18.8105.8105 0 0 1 .27.56v1.78a.8099.8099 0 0 0 1.13.71l2-.87a.75.75 0 0 1 .53 0c.9454.2552 1.9207.383 2.9.38a9.7202 9.7202 0 0 0 9.735-9.705A9.72 9.72 0 0 0 12 2Zm6 7.46-2.93 4.66a1.4999 1.4999 0 0 1-2.17.4l-2.34-1.75a.6001.6001 0 0 0-.72 0l-3.16 2.4a.47.47 0 0 1-.68-.63l2.93-4.66a1.5 1.5 0 0 1 2.17-.4l2.34 1.75a.6001.6001 0 0 0 .72 0l3.16-2.4a.47.47 0 0 1 .68.63Z"/>
  </SvgIcon>
}

export default SolidFacebookMessengerIcon
